import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { useProductsByIds } from "../../../services/productsService";
import { RelatedProductsAddDialog } from "./RelatedProductsAddDialog";

export const RelatedProductsControl = (props) => {
    const { relatedProductIds, setRelatedProductIds, readOnly = false, excludedProductId } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenAddRelatedProductDialog = () => {
        openDialog({
            Component: RelatedProductsAddDialog,
            componentProps: {
                onProductsSelected: setRelatedProductIds,
                excludedProductId: excludedProductId,
                initiallySelectedProductIds: relatedProductIds,
            },
        });
    };

    const { data: relatedProducts } = useProductsByIds(relatedProductIds);

    const handleDeleteRelatedProduct = (productId) => {
        setRelatedProductIds(relatedProductIds.filter((id) => id !== productId));
    };

    return (
        <Paper
            sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                margin: "1rem",
                padding: "1rem",
            }}
        >
            <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
                <Typography variant="h3" align="left" sx={{ width: "100%", fontSize: "1.5rem" }}>
                    {t("products.RelatedProductsControl.title")}
                </Typography>
                {!readOnly && (
                    <IconButton onClick={handleOpenAddRelatedProductDialog}>
                        <AddCircleIcon />
                    </IconButton>
                )}
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    width: "100%",
                    justifyContent: "center",
                }}
            >
                {relatedProducts?.map((product) => (
                    <RelatedProductCard
                        key={product.id}
                        product={product}
                        onDelete={handleDeleteRelatedProduct}
                        readOnly={readOnly}
                    />
                ))}
            </Box>
            {relatedProducts?.length === 0 && (
                <Box sx={{ width: "100%" }}>
                    <Typography variant="body2" color="textSecondary">
                        {readOnly
                            ? t("products.RelatedProductsControl.placeholderReadOnly")
                            : t("products.RelatedProductsControl.placeholder")}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

const RelatedProductCard = (props) => {
    const { product, onDelete, readOnly = false } = props;
    return (
        <Box
            sx={{
                padding: 1,
                border: "1px solid #ccc",
                borderRadius: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Typography variant="body1">{product.name_full}</Typography>
            {!readOnly && (
                <IconButton onClick={() => onDelete(product.id)}>
                    <RemoveCircleIcon color={"error"} />
                </IconButton>
            )}
        </Box>
    );
};
